<script lang="typescript">
    import { state } from "./stores.js";
    import { getCurrency } from "./utils";
    import { activePromotions, eyecarePlanDiscount } from "./offers";
    import { Promotion } from "./types";
    import { scale } from "svelte/transition";
    export let price: number;
    export let classes: string = "";

    const promotions = activePromotions($state);

    const eyeCarePlanPrice = (price) => {
        let eyeCarePlanPrice = (price * (1 - eyecarePlanDiscount($state))) / 24;
        return eyeCarePlanPrice.toFixed(2);
    };
</script>

<div class="price flex flex-col {classes}">
    <slot />
    {#if price === 0}
        <span class="text-4xl font-bold tracking-tight">Included</span>
    {:else}
        <span class="whitespace-nowrap">
            <span class="inline font-bold tracking-tighter">{getCurrency($state)}</span>
            <span
                class="inline text-6xl font-bold tracking-tighter"
                data-testid="price-display-xl-price"
            >
                {price}
            </span>
        </span>
        {#if promotions.includes(Promotion.EYECARE_PLAN)}
            <span class="text-gray-400">Eye care plan price*</span>
            <div
                class="text-green-500 text-xl"
                in:scale={{ start: 1.5, duration: 500, delay: 500 }}
            >
                <span class="font-bold">{getCurrency($state)}{eyeCarePlanPrice(price)} </span>
                <span> per month</span>
            </div>
        {/if}
    {/if}
</div>
